import {
  API_BASE,
  unwrapInvokePayload,
  parseOptionResult,
} from '../data-source-helpers';

export default {
  data() {
    return {
      dsOptions: null,
      dsHint: '',
      dsLoading: false,
      dsLoaded: false,
      dsRawPayload: null,
    };
  },
  computed: {
    dataSourceRef() {
      return this.config && this.config.dataSource;
    },
    dsFetchKey() {
      const ds = this.dataSourceRef;
      if (!ds || ds.id == null || ds.id === '') return '';
      try {
        return JSON.stringify({id: ds.id, option: ds.option || {}});
      } catch (e) {
        return String(ds.id);
      }
    },
    dsFieldMap() {
      const ds = this.dataSourceRef;
      return (ds && ds.map) || null;
    },
    dsGrouped() {
      return !!(this.dsLoaded && this.dsOptions && this.dsOptions.some((o) => o && o.group));
    },
    dsOptionGroups() {
      if (!this.dsGrouped) return [];
      const order = [];
      const map = {};
      (this.dsOptions || []).forEach((o) => {
        const name = (o && o.group) ? String(o.group) : '未分组';
        if (!map[name]) {
          map[name] = {key: name, name, options: []};
          order.push(map[name]);
        }
        map[name].options.push(o);
      });
      return order;
    },
  },
  watch: {
    dsFetchKey: {
      immediate: true,
      handler() {
        this.loadDataSourceOptions();
      },
    },
    dsFieldMap: {
      deep: true,
      handler() {
        this.remapLoadedOptions();
      },
    },
    'config.simple'() {
      this.remapLoadedOptions();
    },
  },
  methods: {
    mergeDataSourceOptions(staticOptions) {
      if (this.dsLoaded) return this.dsOptions || [];
      return staticOptions;
    },
    remapLoadedOptions() {
      if (!this.dsLoaded || this.dsRawPayload == null) return;
      const ds = this.dataSourceRef || {};
      const parsed = parseOptionResult(this.dsRawPayload, {
        map: ds.map,
        simple: !!(this.config && this.config.simple),
      });
      this.dsOptions = parsed.options;
      this.dsHint = parsed.hint || '';
    },
    async loadDataSourceOptions() {
      const ds = this.dataSourceRef;
      if (!ds || ds.id == null || ds.id === '') {
        this.dsOptions = null;
        this.dsHint = '';
        this.dsLoaded = false;
        this.dsLoading = false;
        this.dsRawPayload = null;
        return;
      }
      this.dsLoading = true;
      this.dsHint = '';
      try {
        const res = await this.$api.post(`${API_BASE}/invoke`, {
          id: ds.id,
          params: ds.option || {},
        });
        const payload = unwrapInvokePayload(res);
        this.dsRawPayload = payload;
        const parsed = parseOptionResult(payload, {
          map: ds.map,
          simple: !!(this.config && this.config.simple),
        });
        this.dsOptions = parsed.options;
        this.dsHint = parsed.hint || '';
        this.dsLoaded = true;
      } catch (e) {
        this.dsRawPayload = null;
        this.dsOptions = [];
        this.dsLoaded = true;
        this.dsHint = (e && e.message) || '数据源调用失败';
      } finally {
        this.dsLoading = false;
      }
    },
  },
};
